import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBrushRelaxIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 2,
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			strokeWidth: 1.5,
			d: "m3 8 5 2 5-3 5 1 3-1M3 14l4-1 6 2 4-2 4 1",
			opacity: .25
		}),
		/* @__PURE__ */ _jsx("path", { d: "M3 11h18" }),
		/* @__PURE__ */ _jsx("path", {
			strokeWidth: 1.5,
			d: "M7 7v8M12 7v8M17 7v8",
			opacity: .5
		})
	]
});
export default SvgBrushRelaxIcon;
